// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7fa49823","455":"84493d79","977":"f5b41c4e"}[chunkId] + ".chunk.js";
};